import { render, staticRenderFns } from "./infinite-loading.vue?vue&type=template&id=0226ed86&"
import script from "./infinite-loading.vue?vue&type=script&lang=js&"
export * from "./infinite-loading.vue?vue&type=script&lang=js&"
import style0 from "./infinite-loading.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports